import { apiFetch } from './client.js'

export function listWorkGroups() {
  return apiFetch('/work-groups')
}

export function getWorkGroup(id) {
  return apiFetch(`/work-groups/${id}`)
}

export function createWorkGroup(data) {
  return apiFetch('/work-groups', { method: 'POST', body: data })
}

export function updateWorkGroup(id, data) {
  return apiFetch(`/work-groups/${id}`, { method: 'PATCH', body: data })
}

export function deleteWorkGroup(id) {
  return apiFetch(`/work-groups/${id}`, { method: 'DELETE' })
}

export function addUserToWorkGroup(workGroupId, userId) {
  return apiFetch(`/work-groups/${workGroupId}/users`, {
    method: 'POST',
    body: { user_id: userId },
  })
}

export function removeUserFromWorkGroup(workGroupId, userId) {
  return apiFetch(`/work-groups/${workGroupId}/users/${userId}`, {
    method: 'DELETE',
  })
}

export function addApplicationToWorkGroup(workGroupId, applicationId) {
  return apiFetch(`/work-groups/${workGroupId}/applications`, {
    method: 'POST',
    body: { application_id: applicationId },
  })
}

export function removeApplicationFromWorkGroup(workGroupId, applicationId) {
  return apiFetch(`/work-groups/${workGroupId}/applications/${applicationId}`, {
    method: 'DELETE',
  })
}
